module.exports = __webpack_public_path__ + "img/FHWP_hammer.2ab8921a.png";